module.exports = __webpack_public_path__ + "static/img/identity.2e407b3e.png";